import { batch } from 'react-redux';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import { SelectPurchaseOptionPopup } from '~/src/components/SelectPurchaseOptionPopup';
import { TConfirmParams } from '~/src/components/SelectPurchaseOptionPopup/types';
import { setIsShowDetails, setIsShowOptionSelect } from '~/src/features/work-in-home-ab/components/Description/components/TestDrive/context/actions';
import { useContextDispatch, useContextSelector } from '~/src/features/work-in-home-ab/components/Description/components/TestDrive/context/hooks';

import TestDriveBanner from './components/Banner';
import TestDriveDetails, { IPurchaseOption } from './components/Details';
import { getBannerData } from './helpers';

export interface IProps {
    equipment: IEquipment,
    onChangeOption: (optionId: string | number, variantId: string | number) => void,
    onOrder: () => void,

    purchaseOption?: IPurchaseOption,
}

const TestDriveWrapper = ({ equipment, onChangeOption, onOrder, purchaseOption }: IProps): JSX.Element | null => {
    const dispatch = useContextDispatch();

    const { isShowOptionSelect } = useContextSelector(state => state);

    const { category, testDrive } = equipment;

    if (!testDrive) {
        return null;
    }

    const bannerData = getBannerData(testDrive, category);

    const onShowDetails = () => {
        dispatch(setIsShowDetails(true));
    };

    const onHideSelect = () => {
        batch(() => {
            dispatch(setIsShowOptionSelect(false));
            dispatch(setIsShowDetails(true));
        });
    };

    const onConfirmSelect = ({ payOption: { optionId, variantId } }: TConfirmParams) => {
        onChangeOption(optionId, variantId);
        onHideSelect();
    };

    return (
        <>
            <TestDriveBanner onBannerClick={onShowDetails} {...bannerData}/>
            <TestDriveDetails
                equipment={equipment}
                onOrder={onOrder}
                purchaseOption={purchaseOption}
            />
            <SelectPurchaseOptionPopup
                isOpen={isShowOptionSelect}
                equipment={equipment}
                onConfirmSelect={onConfirmSelect}
                onClose={onHideSelect}
                isOnlyTestDrive
            />
        </>
    );
};

export default TestDriveWrapper;
